"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDriversLicenseNumber = void 0;
function validateDriversLicenseNumber(dlNumber) {
    if (dlNumber === undefined || dlNumber === null) {
        return true;
    }
    if (!dlNumber.length) {
        return false;
    }
    // if length is 1 only allow numbers
    if (/^\d$/.test(dlNumber)) {
        return true;
    }
    if (/^\D$/.test(dlNumber)) {
        return false;
    }
    if (/\s$/.test(dlNumber)) {
        return false;
    }
    // attempt to find a masking character and only allow that special char in the pattern
    const possibleMaskDigit = dlNumber.replace(/[a-z\d\s]/gi, '')[0] || '';
    const dlPattern = new RegExp(`^[\\dA-Za-z\\s${possibleMaskDigit}]{1,19}$`);
    return dlPattern.test(dlNumber);
}
exports.validateDriversLicenseNumber = validateDriversLicenseNumber;
